import Konva from "konva";
import Helpers from '../Helpers';
import ConfiguratorData from './ConfiguratorData';
import Popup from "./partials/Popup";

let object = null;

class ConfiguratorSofa {

    constructor(configurator) {

        if(!object) {
            object = this;
        }

        /*Состояние канваса. Содержит текущие модули в области построения*/
        this.state = [];
        this.helpers = new Helpers();
        this.configData = new ConfiguratorData();
        this.configurator = configurator;
        this.canvas = $('#configurator-canvas');

        /*Крайние модули*/
        this.edgeModules = {
            'first' : {},
            'last' : {}
        };

        /*Масштаб картинок*/
        this.scale = 0.3;

        /*Фикс. размер картинок*/
        this.imageSize = 1200;

        /*Линейка*/
        this.linearGroup = new Konva.Group({
            x: 0,
            y: 0,
        });
        this.linear = {
            x1: 0,
            x2: 0,
            xMax: 0,
            y1: 0,
            y2: 0,
            yMax: 0,
            z: 0,
            show: true
        };

        this.maxWidth = 5500;

        /*Общий контейнер Konva*/
        this.groupX = 410;
        this.groupY = 120;
        this.group = new Konva.Group({
            x: this.groupX,
            y: this.groupY,
            draggable: false
        });

        /*Точка отсчета*/
        this.position = {
            x: 0,
            y: 0,
        };

        this.topWrapper = $('.constructor-canvas')
        this.sofaId = this.topWrapper.data('sofa-id');
        this.hasPillows = this.topWrapper.data('has-pillows');

        /*ID текущего дивана*/
        this.currentSofa = this.helpers.findGetParameter('sofa');

        if(this.currentSofa === null || typeof this.currentSofa === 'undefined') {
            this.currentSofa = this.sofaId;
        }

        /*Существует ли кресло*/
        this.chair = {
            exists: false
        }

        /*listen options*/
        this.debug = (window.location.hash === '#debug');

        this.coordinatesShape = {};

        /*Получаем фразы для перевода*/
        this.helpers.getTranslatedPhrases(['см', 'грн'], this);

        return object;
    }

    /*Удалить серые модули-фантомы*/
    removeHighlighted() {
        let object = this;
        object.configurator.blockTargetItems = false

        object.state = object.state.filter(function( obj ) {
            return !obj.highlight;
        });
    }

    /*Удалить серые модули-фантомы*/
    removeTargetItems() {
        let object = this;
        object.configurator.targetItems = false

        object.state = object.state.filter(function( obj ) {

            if(obj.targetItem) {
                object.helpers.processChairPosition(obj, object, true);
            }

            return !obj.targetItem;
        });
    }

    // Построить из state
    rebuild() {
        let object = this;

        /*Если немодульный диван, то вызываем метод для обработки первого модуля*/
        if(object.configData.noModuleSofa) {
            object.configurator.noModuleSofa.makeFirstModuleAsAngle();
        }

        object.position = {
            x: 0,
            y: 0,
        };

        object.chair = {
            exists: false,
            prepends: false
        };

        let startPosition = object.helpers.getStartPoint(object.state, object.sections);
        object.position.x = startPosition.x;
        object.position.y = startPosition.y;

        object.group.removeChildren();

        // console.log(' object.state on rebuild',  object.state);

        if(object.state.length === 1) {

            if(object.state[0].isAngle) {
                if(object.state[0].position !== 'front' || object.state[0].position !== 'frontRight') {

                    if(object.state[0].position === 'frontRight') {
                        object.state[0].position = 'frontRight';
                    }
                    else {
                        object.state[0].position = 'front';
                    }

                    object.state[0].prepends = false;
                }
            }
            else {
                if(object.state[0].position !== 'front') {
                    object.state[0].position = 'front';
                    object.state[0].prepends = false;
                }
            }
        }

        object.state.forEach((item, index) => {

            item.index = index;
            object.drawSection(item, index);

            if(item.isChair && item.highlight !== 1) {
                object.chair = {
                    exists: true,
                    prepends: item.prepends,
                    item: item
                };
            }
        });

        if(object.debug) {
            let startPointCircle = new Konva.Circle({
                x: startPosition.x,
                y: startPosition.y,
                radius: 5,
                fill: 'yellow',
            });

            object.group.add(startPointCircle);
        }

    }

    // Добавить секцию в state
    addSection(data) {
        let object = this;
        let frontLeft = 0, frontRight = 0;
        let firstElement = "";
        let firstElementL = "";

        for (var i = 0; i < object.state.length ; i++)
        {
            if (object.state[i].position === "frontLeft") frontLeft++;
            else if (object.state[i].position === "frontRight" || object.state[i].position === "front") frontRight++;

            if (object.state[i].position === "front") firstElement = object.state[i];

            if(object.state[i].position === "frontLeft" && firstElementL === "" ) firstElementL = object.state[i];
        }

        const defaults = {
            _id: object.group.children.length,
            id: 0,
            rotate: 1,
            highlight: 0,
            targetItem: false,
            prepends: false,
            position: 'front',
            isAngle: false,
            pushToStart: false,
            shiftedX: 0,
            shiftedY: 0
        };

        data = Object.assign(defaults, data);

        let edges = object.helpers.getEdgeModuleIndex(object)


        if(object.state.length > 0){

            if(
                firstElement.connectedModule === "KATARINA 120KAT-150-CHL Кушетка" &&
                data.position === "frontLeft" 
                ||
                data.connectedModule === "SOHO 125SO-110-AL модуль с левым подлокотником" &&
                firstElement.connectedModule === "SOHO 100SO-110-AN прямой модуль" &&
                data.position === "frontLeft" &&
                frontLeft === 0 
                ||
                data.connectedModule === "SOHO 110SO-110-CL угловой левый модуль" &&
                firstElement.connectedModule === "SOHO 100SO-110-AN прямой модуль" &&
                data.position === "frontLeft" &&
                frontLeft === 0 
                ||
                data.connectedModule === "ERMES 143ER-120-P пуф" &&
                firstElement.connectedModule === "ERMES 120ER-141-AN прямий сегмент" &&
                data.position === "frontLeft"
                ||
                object.state[0].connectedModule === "Appiani 245AP-126 CHLL двойной модуль левый" &&
                data.position === "frontLeft" &&
                frontLeft === 0 
                ||
                data.connectedModule === "Appiani 245AP-126 CHLR двойной модуль правый" &&
                object.state[0].connectedModule === "Appiani 245AP-126 CHLL двойной модуль левый" &&
                data.position === "frontRight" &&
                frontRight === 1 
                ||
                data.connectedModule === "Appiani 110AP-126-AN прямой модуль" &&
                object.state[0].connectedModule === "Appiani 126AP-126 CL угловой модуль левый" &&
                data.position === "front" &&
                frontRight === 1 
                ||
                object.state[0].connectedModule === "ERMES 172ER-141-CTL модуль со столиком слева" &&
                data.position === "frontLeft" &&
                frontLeft === 0 
                ||
                object.state[0].connectedModule === "ERMES 196ER-141-AL-CTR модуль с левым подлокотником и правым столиком" &&
                data.position === "frontLeft" &&
                frontLeft === 0 
                ||
                data.connectedModule === "Appiani 126AP-126 CL угловой модуль левый" && 
                object.state[0].connectedModule === "Appiani 150AP-126-AL модуль с подлокотником левый" &&
                data.position === "frontRight" &&
                frontRight === 1
                ||
                data.connectedModule === "TUTTO U 144TU-144-CL Угловой левый модуль" &&
                object.state[0].connectedModule === "TUTTO U 144TU-144-CL Угловой левый модуль" &&
                 data.position === "frontLeft" &&
                frontLeft === 0 
                ||
                data.connectedModule === "TUTTO 115TU-115-CL Угловой левый модуль" &&
                object.state[0].connectedModule === "TUTTO U 144TU-144-CL Угловой левый модуль" &&
                 data.position === "frontLeft" &&
                frontLeft === 0 
                 ||
                data.connectedModule === "TUTTO 129TU-115-AL Модуль с левым подлокотником" &&
                object.state[0].connectedModule === "TUTTO U 144TU-144-CL Угловой левый модуль" &&
                 data.position === "frontLeft" &&
                frontLeft === 0 
                ||
                data.connectedModule === "Appiani 126AP-126 CL угловой модуль левый" &&
                object.state[0].connectedModule === "Appiani 245AP-126 CHLL двойной модуль левый" &&
                data.position === "frontRight" &&
                frontRight === 1
            )
            {
                return false;
            }
        } 
       /* else if (data.connectedModule === "TUTTO U 144TU-144-CL Угловой левый модуль") {
            return false;
        }*/


        if(object.chair.exists) {

            if(data.isChair) {
                if(data.prepends === true || data.pushToStart) {
                    object.state.unshift(data);
                }
                else {
                    object.state.push(data);
                }
            }
            else {
                if(data.prepends || data.pushToStart) {
                    object.state.splice( edges.firstIndex, 0, data );
                }
                else {
                    object.state.splice( edges.lastIndex + 1, 0, data );
                }

                object.helpers.processChairPosition(data, object);
            }
        }
        else {
            if(data.prepends === true || data.pushToStart) {
                object.state.unshift(data);
            }
            else {
                object.state.push(data);
            }
        }

        /*применяем сдвиг для модулей, у которых он указан*/
        object.helpers.addShift(object)

        return data;
    }

    /**
     * Рисуем секцию
     * @param item - данные о текущем модуле (sofa.state)
     * @param index - индекс текущего модуля
     * */
    drawSection(item, index) {
        let object = this;

        // xooo
        // oooo
        // Кординаты левой верхней точки дивана

        let position = object.getNewSectionCoordinates(item, item.position);

        if(object.configData.noModuleSofa) {
            /*Если у нас немодульный диван то используем специальную обертку для получения координат*/
            position = object.configurator.noModuleSofa.correctCoordinates(position, item);
        }

        let queuePosition = item.prepends ? 'prepend' : 'append';
        let sectionObject = object.sections[item.id];

        let x = position.x;
        let y = position.y;
        item.x = x;
        item.y = y;

        //console.log(object.scale);

        if(position !== false) {

            /**
             * Для того чтоб нарисовать модуль сначала необходимо получить изображения
             * (именно объекты, а не просто URL)
             * Также их нужно получить в соответствии с текущим разворотом
             * */
            let img, shadowImg, pillow, pillowSrc, src;
            if(item.position === 'front') {
                img = sectionObject['image']['front']['img'];
                src = sectionObject['image']['front']['src'];
                shadowImg = sectionObject['image']['front']['shadowImg']
                pillow = sectionObject['image']['front']['pillowImg'];
                pillowSrc = sectionObject['image']['front']['pillow'];
            }
            else if (item.position === 'frontLeft') {
                img = sectionObject['image']['frontLeft']['img'];
                src = sectionObject['image']['frontLeft']['src'];
                shadowImg = sectionObject['image']['frontLeft']['shadowImg']
                pillow = sectionObject['image']['frontLeft']['pillowImg'];
                pillowSrc = sectionObject['image']['frontLeft']['pillow'];
            }
            else if(item.position === 'frontRight'){
                img = sectionObject['image']['frontRight']['img'];
                src = sectionObject['image']['frontRight']['src'];
                shadowImg = sectionObject['image']['frontRight']['shadowImg']
                pillow = sectionObject['image']['frontRight']['pillowImg'];
                pillowSrc = sectionObject['image']['frontRight']['pillow'];
            }
            else {
                img = sectionObject['image']['back']['img'];
                src = sectionObject['image']['back']['src'];
                shadowImg = sectionObject['image']['back']['shadowImg']
                pillow = sectionObject['image']['back']['pillowImg'];
                pillowSrc = sectionObject['image']['back']['pillow'];
            }

            //инфо для консоли
            item.pillowImg = pillowSrc
            item.src = src

            /*Изображение модуля*/
            let image = new Konva.Image({
                x: sectionObject.flip ? (x + object.imageSize * object.scale) : x, /*проверяем flip, сдвигаем изображение*/
                y: y,
                width: object.imageSize,
                height: object.imageSize,
                listening: object.debug,
                draggable: object.debug,
                image: img,
                scaleX: sectionObject.flip ? (object.scale * -1) : object.scale, /*проверяем flip, зеркалим картинку*/
                scaleY: object.scale,
                name: 'image-' + item.id,
            });

            /*дополнительная инфо о изображении*/
            image.objectPosition = position.objectPosition;
            image.info = {
                item: item,
                moduleId: item.id,
                position: item.position,
                queuePosition: queuePosition,
                sizeX: object.sections[item.id]['image'][item.position][queuePosition]['sizeX'],
                sizeY: object.sections[item.id]['image'][item.position][queuePosition]['sizeY'],
                offsetX: object.sections[item.id]['image'][item.position][queuePosition]['offsetX'],
                offsetY: object.sections[item.id]['image'][item.position][queuePosition]['offsetY'],
                shiftX: object.sections[item.id]['image'][item.position][queuePosition]['shiftX'],
                shiftY: object.sections[item.id]['image'][item.position][queuePosition]['shiftY']
            };

            /*Тень модуля*/
            let shadow = new Konva.Image({
                x: sectionObject.flip ? (x + object.imageSize * object.scale) : x,
                y: y,
                listening: false,
                image: shadowImg,
                width: object.imageSize,
                height: object.imageSize,
                scaleX: sectionObject.flip ? (object.scale * -1) : object.scale,
                scaleY: object.scale,
                name: 'shape' + x + '-' + y,
            });

            /*Подушка модуля*/
            let pillowItem = new Konva.Image({
                x: sectionObject.flip ? (item.x + object.imageSize*object.scale) : item.x,
                y: item.y,
                listening: false,
                width: object.imageSize,
                height: object.imageSize,
                image: pillow,
                scaleX: sectionObject.flip ? (object.scale * -1) : object.scale,
                scaleY: object.scale,
                name: 'image-pillow-' + item.id,
            })

            /*Подсвечиваем серым, если мы еще не поставили модуль на место, а только таскаем его*/
            if(item.highlight) {
                image.filters([Konva.Filters.Grayscale])
                image.cache()
            }
            else if(item.targetItem) {
                image.opacity(0.4)
                image.cache()
            }
            else {
                object.configurator.saveState(object.state)
            }

            // let imageData = object.helpers.getImageData(img);

            /*Обводка модуля*/
            let strokeShape = object.customImageBorder([], x, y, sectionObject, item)
            strokeShape.stateId = index

            /*Добавляем все элементы в группу последовательно*/
            if(!item.targetItem) {
                object.group.add(shadow)
                object.group.add(image)
                object.group.add(strokeShape)
                object.group.add(pillowItem)
            }
            else {
                object.group.add(image)
            }

            /*проставление Z-INDEX для всех элементов*/
            shadow.zIndex(0)

            if(item.position === 'frontLeft' && !item.isAngle) {
                image.zIndex((object.group.children.length - image.index) - 1)
                pillowItem.zIndex((object.group.children.length - image.index) + 2)
                strokeShape.zIndex((object.group.children.length - strokeShape.index) + 1)
            }

            if(item.position === 'frontLeft' && item.isAngle) {
                image.zIndex((object.group.children.length - image.index) - 1)
                pillowItem.zIndex((object.group.children.length - pillowItem.index) + 2)
                strokeShape.zIndex((object.group.children.length - strokeShape.index) + 1)
            }

            if(item.position === 'back' && !item.isAngle) {
                image.zIndex((object.group.children.length - image.index) - 1)
                pillowItem.zIndex((object.group.children.length - pillowItem.index) + 2)
                strokeShape.zIndex((object.group.children.length - strokeShape.index) + 1)
            }

            if(item.position === 'front' && item.isAngle) {
                image.zIndex(1)
                pillowItem.zIndex(2)
                strokeShape.zIndex(3)
            }

            /*подключение режима дебага*/
            object.turnOnDebug(x, y, image, strokeShape, pillowItem, object.debug)
        }

    }

    /*Определить какие модули доступны к построению*/
    checkAvailableItems(sizeX, on = 'size') {
        let object = this;
        let angle = $('.isAngle').parents('.options__module');
        let mirrors = $('.isMirror').parents('.options__module');
        let armrests = $('.isArmrest').parents('.options__module');
        let puffs = $('.isPuff').parents('.options__module');
        let chairs = $('.isChair').parents('.options__module');

        if(object.state.length > 0) {

            /*Ограничение по размеру*/
            for(let id in object.sections) {

                let currentModule = $('[data-id="'+ id +'"]').parents('.options__module');

                if(sizeX + object.sections[id].sizeX > object.maxWidth) {
                    currentModule.addClass('inactive');
                }
                else {
                    currentModule.removeClass('inactive');
                }
            }

            let anglesCount = 0;
            object.anglesCount = 0;

            object.state.forEach(function(item, index) {
                if(item.isAngle && !item.isArmrest) {
                    anglesCount++;
                    object.anglesCount++;
                    // angle.addClass('inactive');

                    $('[data-mirror="'+ (item.id+1) +'"]').parents('.options__module').removeClass('inactive');
                    $('[data-id="'+ item.id +'"]').parents('.options__module').removeClass('inactive');
                    $('[data-id="'+ item.mirrorOf +'"]').parents('.options__module').removeClass('inactive');

                    armrests.removeClass('inactive');

                    if(anglesCount > 3) {
                        angle.addClass('inactive');
                    }
                }
            });
        }
        else {
            $('.options__module').removeClass('inactive');
            angle.removeClass('inactive');
            mirrors.removeClass('inactive');
            puffs.addClass('inactive');
            chairs.addClass('inactive');
        }

        if(object.state.length >= 20) {
            $('.options__module').addClass('inactive');
        }
    }

    // Расчет реальных длинн сторон дивана, где:
    // x1 x2 - длинна левой и правой стороны, xMax - большая из них
    // y1 y2 - длинна передней и задней стороны, yMax - большая из них
    // все величины в реальных см.
    calculateLinear() {
        let object = this;
        let z, x1, x2, y1, y2, xMax, yMax, floatingX, floatingY;

        /*If no sections drawn set linear sizes to 0 and return*/
        if(object.state.length === 0) {

            object.linear = {
                x1: 0,
                x2: 0,
                xMax: 0,
                y1: 0,
                y2: 0,
                yMax: 0,
                z: 0,
                show: true
            };

            return;
        }

        /*fill x, y, z*/
        z = 0;
        xMax = 0;
        yMax = 0;
        x1 = 0;
        x2 = 0;
        y1 = 0;
        y2 = 0;
        floatingX = 0;
        floatingY = 0;
        console.debug(object.state);
        object.state.forEach((item, index) => {

            let sectionObject = object.sections[item.id];
            let sizeX = sectionObject['sizes']['x'];
            let sizeY = sectionObject['sizes']['y'];
            let sizeZ = sectionObject['sizes']['z'];

            if(sizeZ > z) {
                z = sizeZ;
            }

            if(item.isAngle) {
                if(item.isMirror) {
                    if(item.position === 'front') {
                        x1 += sizeX;
                        y1 += sizeY;
                        
                        if(item.connectedModule == "BOTTERA 1215BO-177-CHLR шезлонг с правым подлокотником"){
                            y1 = item.sizes.x;
                            x1 = item.sizes.y;
                        }
                    }
                    else if(item.position === 'frontLeft') {
                        x1 += sizeY;
                        y2 += sizeX;

                        if(x2 < item.sizes.y && item.connectedModule == "BOTTERA 1215BO-177-CHLR шезлонг с правым подлокотником"){
                            y2 = item.sizes.y;
                            x1 = item.sizes.x;
                        }
                    }
                    else if(item.position === 'frontRight') {
                        if(item.connectedModule == "Appiani 245AP-126 CHLR двойной модуль правый"){
                            y1 += sizeY;
                            x2 += sizeX;
                        } else {
                            y1 += sizeX;
                            x2 += sizeY;
                        }
                    }
                    else if(item.position === 'back') {
                        x2 += sizeX;
                        y2 += sizeY;
                    }
                }
                else {
                    if(item.position === 'front') {
                        x1 += sizeY;
                        y1 += sizeX;
                    }
                    else if(item.position === 'frontLeft') {
                        x1 += sizeX;
                        y2 += sizeY;
                    }
                    else if(item.position === 'frontRight') {
                        y1 += sizeY;
                        x2 += sizeX;
                    }
                    else if(item.position === 'back') {
                        x2 += sizeY;
                        y2 += sizeX;
                    }
                }
            }
            else {
                if(item.position === 'frontLeft') {
                    if(item.connectedModule == "ERMES 143ER-120-P пуф")
                        x1 += sizeY;
                    else
                        x1 += sizeX;



                    if(floatingY === 0) {
                        floatingY = sizeX;
                    }
                }
                else if(item.position === 'front') {
                    if(
                        x2 < item.sizes.y && item.connectedModule == "BOTTERA 1215BO-177-CHLL шезлонг с левым подлокотником" || 
                        x2 < item.sizes.y && item.connectedModule == "KATARINA 120KAT-150-CHL Кушетка"
                    )
                        x2 = item.sizes.y;
                    
                    y1 += sizeX;
                    if(floatingX === 0) {
                        floatingX = sizeY;
                    }
                }
                else if(item.position === 'frontRight') {
                    if(item.connectedModule == "ERMES 143ER-120-P пуф")
                        x2 += sizeY;
                    else
                        x2 += sizeX;

                    if(floatingY === 0) {
                        floatingY = sizeX;
                    }
                }
                else if(item.position === 'back') {
                    y2 += sizeX;

                    if(floatingX === 0) {
                        floatingX = sizeY;
                    }
                }
            }
        });

        console.log('floatingX', floatingX);
        console.log('floatingY', floatingY);

        console.log('x1', x1)
        console.log('x2', x2)
        console.log('y1', y1)
        console.log('y2', y2)

        if(x1 === 0) x1 = floatingX;
        if(x2 === 0) x2 = floatingX;
        if(y1 === 0) y1 = floatingY;
        if(y2 === 0) y2 = floatingY;

        if (x1 >= x2) xMax = x1; else xMax = x2;
        if (y1 >= y2) yMax = y1; else yMax = y2;

        if(xMax === 0) {
            xMax = floatingX;
        }
        if(yMax === 0) {
            yMax = floatingY;
        }

        //пример размеров дивана для тестирования
        // console.log('x1: ' + x1 + ' x2: ' + x2 + ' xMax: ' + xMax + ' | y1: ' + y1 + ' y2: ' + y2 + ' yMax: ' + yMax);

        /*set linear sizes*/
        object.linear.x1 = x1;
        object.linear.x2 = x2;
        object.linear.xMax = xMax;
        object.linear.y1 = y1;
        object.linear.y2 = y2;
        object.linear.yMax = yMax;
        object.linear.z = z;
    }

    // Нарисовать линии размеров
    // ДЛЯ ПОНИМАЯ ДВУХ СИСТЕМ ВЫБРАЛ ТАКИЕ ОБОЗНАЧЕНИЯ КОРДИНАТ
    // Оси 3D системы https://noch-ein-hr-blog.de/wp-content/uploads/2015/08/Xyz.gif
    // Оси 2D системы https://dmpublisher.s3-us-west-2.amazonaws.com/old-dm/directionsmag.com/ee/images/newsletter/2009/01_week5/XandY_axes.jpg
    drawLinear() {

        let object = this;

        object.linearGroup.removeChildren();

        let drawnSections = object.helpers.getDrawnSectionsArray(object.sections, object.state);

        if(drawnSections.length === 0) {
            return false;
        }

        //------------------параметры-------------------------

        let mainSkew = 41; //Узнать у 3дшника

        let yLineShiftX = object.group.attrs.x + 66; //Смещение X 2D системы кординат к 3D (подобрано и зависит от положения дивана в 2D)
        let yLineShiftY = object.group.attrs.y + 67; //Смещение Y 2D системы кординат к 3D (подобрано и зависит от положения дивана в 2D)

        // TODO умножить на масштаб дивана при скейле
        let scaleRealToPixel = 8.4 / object.group.scaleX(); //соотношение масштаба дивана в см к пикселям на экране. (подобрано - что б длинна линий совпадала с длинной дивана)

        let indent = 30 * object.group.scaleX(); //отступ линий от дивана

        //------------------------------------------------------

        let angle3D2D = (180 - (180 * Math.sin(mainSkew * Math.PI/180))) / 2; // Левый и правый углы дивана в 2D проекции (они мнее 45, так как сцена в перспективе)
        let cathetBiggest = Math.sin((90 - angle3D2D) * Math.PI/180); //коэфициент большего катета треугольника
        let cathetSmaller = Math.cos((90 - angle3D2D) * Math.PI/180); //коэфициент меньшего катета треугольника

        let xMaxResized = object.linear.xMax / scaleRealToPixel;
        let yMaxResized = object.linear.yMax / scaleRealToPixel;

        let magicCoefficient = 3; //Пока необъяснимый коэффициент. Как то зависит от mainSkew, ф-ла не найдена (подобрано)

        // Начальная точка (центр низ) - для Y и X
        let StartX = yLineShiftX + yMaxResized * cathetBiggest - xMaxResized * cathetSmaller - xMaxResized / magicCoefficient;
        let StartY = yLineShiftY + yMaxResized * cathetSmaller + xMaxResized * cathetBiggest - xMaxResized / magicCoefficient;

        /*console.log('object.frontLeftCount', object.frontLeftCount);
        console.log('object.frontRightCount', object.frontRightCount);
        console.log('object.frontCount', object.frontCount);
        console.log('object.angleFrontRight', object.angleFrontRight);
        console.log('object.angleFrontLeft', object.angleFrontLeft);
        console.log('object.angleFront', object.angleFront);
        console.log('object.angleBack', object.angleBack);*/

        if(object.chair.exists) {
            if(object.chair.item.position === 'front') {
                if(object.frontCount < 2) {
                    indent += 60;
                }
                else if (object.frontCount < 3) {
                    indent += 30;
                }
            }
            if(object.chair.item.position === 'frontRight') {
                indent += 10;
            }
            if(object.chair.item.position === 'frontLeft') {
                indent += 15;
            }
        }

        //-----------------------Y---------------------------

        // Начальная точка (центр низ)
        let yLineStartX = StartX - indent * cathetBiggest;
        let yLineStartY = StartY + indent * cathetSmaller;

        // Конечная точка (лево) - считаем пифагором через длинну
        let yLineEndX = yLineStartX - yMaxResized * cathetBiggest;
        let yLineEndY = yLineStartY - Math.sqrt(Math.pow(yMaxResized, 2) - Math.pow((yMaxResized * cathetBiggest), 2));

        let lineY = new Konva.Shape({
            stroke: 'white',
            strokeWidth: 1,
            shadowColor: 'black',
            shadowBlur: 5,
            shadowOffset: { x: 0, y: 0 },
            shadowOpacity: 1,
            sceneFunc: function (context, shape) {
                context.beginPath();
                context.moveTo(yLineStartX+3, yLineStartY-2);
                context.lineTo(yLineStartX-4, yLineStartY+2);
                context.moveTo(yLineStartX, yLineStartY);
                context.lineTo(yLineEndX, yLineEndY);
                context.moveTo(yLineEndX+3, yLineEndY-2);
                context.lineTo(yLineEndX-4, yLineEndY+2);
                context.closePath();
                context.fillStrokeShape(shape);
            }
        });

        let textY = new Konva.Text({
            rotation: angle3D2D,
            height: 30,
            width: 100,
            align: 'left',
            x: yLineStartX - (yMaxResized * cathetBiggest) / 2 - 40, //не идеально
            y: yLineStartY - (yMaxResized * cathetSmaller) / 2 - 15, //не идеально
            text: object.linear.yMax + ' ' + object.configData.translatedPhrases['см'],
            fontSize: 19,
            fontFamily: 'Circe',
            fill: 'white',
            shadowColor: 'black',
            shadowBlur: 5,
            shadowOffset: { x: 0, y: 0 },
            shadowOpacity: 1,
        });

        //-----------------------X---------------------------

        // Начальная точка (центр низ)
        let xLineStartX = StartX + indent * cathetBiggest;
        let xLineStartY = StartY + indent * cathetSmaller;

        // Конечная точка (право)
        let xLineEndX = xLineStartX + xMaxResized * cathetBiggest;
        let xLineEndY = xLineStartY - xMaxResized * cathetSmaller;

        let lineX = new Konva.Shape({
            stroke: 'white',
            strokeWidth: 1,
            shadowColor: 'black',
            shadowBlur: 5,
            shadowOffset: { x: 0, y: 0 },
            shadowOpacity: 1,
            sceneFunc: function (context, shape) {
                context.beginPath();
                context.moveTo(xLineStartX-4, xLineStartY-2);
                context.lineTo(xLineStartX+3, xLineStartY+3);
                context.moveTo(xLineStartX, xLineStartY);
                context.lineTo(xLineEndX, xLineEndY);
                context.moveTo(xLineEndX-4, xLineEndY-2);
                context.lineTo(xLineEndX+3, xLineEndY+3);
                context.closePath();
                context.fillStrokeShape(shape);
            }
        });

        let textX = new Konva.Text({
            rotation: -angle3D2D,
            height: 30,
            width: 100,
            align: 'left',
            x: xLineStartX + (xMaxResized * cathetBiggest) / 2 - 10, //не идеально
            y: xLineStartY - (xMaxResized * cathetSmaller) / 2 + 15, //не идеально
            text: object.linear.xMax + ' ' + object.configData.translatedPhrases['см'],
            fontSize: 19,
            fontFamily: 'Circe',
            fill: 'white',
            shadowColor: 'black',
            shadowBlur: 5,
            shadowOffset: { x: 0, y: 0 },
            shadowOpacity: 1,
        });

        //-----------------------Z---------------------------

        let zLineStartX = xLineEndX;
        let zLineStartY = xLineEndY - 15;
        let zLineEndX = zLineStartX;
        let zLineEndY = zLineStartY - 100;

        let lineZ = new Konva.Shape({
            stroke: 'white',
            strokeWidth: 1,
            shadowColor: 'black',
            shadowBlur: 5,
            shadowOffset: { x: 0, y: 0 },
            shadowOpacity: 1,
            sceneFunc: function (context, shape) {
                context.beginPath();
                context.moveTo(zLineStartX-3, zLineStartY);
                context.lineTo(zLineStartX+3, zLineStartY);
                context.moveTo(zLineStartX, zLineStartY);
                context.lineTo(zLineEndX, zLineEndY);
                context.moveTo(zLineEndX-3, zLineEndY);
                context.lineTo(zLineEndX+3, zLineEndY);
                context.closePath();
                context.fillStrokeShape(shape);
            }
        });

        let textZ = new Konva.Text({
            rotation: -90,
            height: 30,
            width: 100,
            align: 'left',
            x: zLineStartX + 10,
            y: zLineStartY - (zLineStartY - zLineEndY) / 2 + 30, //не идеально
            text: object.linear.z + ' ' + object.configData.translatedPhrases['см'],
            fontSize: 19,
            fontFamily: 'Circe',
            fill: 'white',
            shadowColor: 'black',
            shadowBlur: 5,
            shadowOffset: { x: 0, y: 0 },
            shadowOpacity: 1,
        });

        object.linearGroup.add(lineY);
        object.linearGroup.add(lineX);
        object.linearGroup.add(lineZ);

        object.linearGroup.add(textY);
        object.linearGroup.add(textX);
        object.linearGroup.add(textZ);

    }

    /*Рассчет цены*/
    /*Calculate final Price*/
    calculatePrice() {
        let $item = $('.js-material-item.is-current').eq(0);
        let object = this;
        let materialTypeId = $item.data('material-type-id');

        $.ajax({
            url: ajaxurl,
            dataType: 'json',
            type: 'post',
            data: {
                action: 'change_material_price',
                materialTypeId: materialTypeId,
                modules: object.state
            },
            beforeSend: function() {

            },
            success: function (response) {
                let finalPrice = 0;
                let currentSofa = object.configData.sections[0];

                if (response.success) {
                    finalPrice = object.helpers.formattedPrice(response.totalPrice);

                    $('.js-configurator-price').text(finalPrice);

                    response.modules.forEach((item, index) => {
                        currentSofa[item.id]['price'] = item.price;
                    })
                }
                else {
                    object.state.forEach((item, index) => {
                        finalPrice += object.sections[item.id].price;
                    });

                    finalPrice = object.helpers.formattedPrice(finalPrice);

                    $('.js-configurator-price').text(finalPrice);
                }

            },
            complete: function () {

            }
        })
    }

    /*Построить обводку из заранее заданных координат*/
    /*BUILD BORDER FROM CUSTOM COORDINATES*/
    customImageBorder(imageData, x, y, sectionItem, item) {

        let object = this;
        let coordinates;
        /* AUTOMATIC COORDINATES */
        if(item.position === 'front') {
            coordinates = sectionItem['image']['front']['coordinates'];
        }
        else if (item.position === 'frontLeft'){
            coordinates = sectionItem['image']['frontLeft']['coordinates'];
        }
        else if (item.position === 'back'){
            coordinates = sectionItem['image']['back']['coordinates'];
        }
        else {
            coordinates = sectionItem['image']['frontRight']['coordinates'];
        }

        let shape =  new Konva.Shape({
            x: x,
            y: y,
            scaleX: object.scale,
            scaleY: object.scale,
            strokeWidth: 0,
            stroke: 'white',
            fillEnabled: true,
            listening: true,
            width: object.imageSize,
            height: object.imageSize,
            name: 'strokeShape',
            sceneFunc: function (context, shape) {
                context.beginPath();

                if(coordinates.length > 0 && typeof coordinates !== "undefined") {
                    context.moveTo(coordinates[0].x, coordinates[0].y);

                    for(let i = 0; i < coordinates.length; i++) {
                        context.lineTo(coordinates[i].x, coordinates[i].y);
                    }
                }

                context.closePath();
                context.fillStrokeShape(shape);
            }
        });

        shape.coordinates = coordinates;

        return shape;
    }

    /**
     * В зависимости от позиционирования получить координаты размещения нового блока
     * @param item - новый модуль
     * @param position - текущая позиция модуля
     * */
    /*get coordinates of new block*/
    getNewSectionCoordinates(item, position) {
        let object = this;
        let x;
        let y;
        let sectionObject = object.sections[item.id];
        let objectPosition = Object.assign({}, object.position);
        let queuePosition;
        object.frontRightCount = 0;
        object.frontLeftCount = 0;
        object.frontCount = 0;
        object.backCount = 0;
        object.angleFrontRight = false;
        object.angleFrontLeft = false;
        object.angleBack = false;
        object.angleFront = false;

        if(typeof item.shiftedX === "undefined") {
            item.shiftedX = 0
        }
        if(typeof item.shiftedY === "undefined") {
            item.shiftedY = 0
        }

        for(let i=0; i< object.state.length; i++) {

            if (object.state[i]['position'] === 'frontRight' && !object.state[i]['isChair']) {
                object.frontRightCount++;

                if(object.state[i].isAngle) {
                    object.angleFrontRight = true;
                }
            }
            if (object.state[i]['position'] === 'front' && !object.state[i]['isChair']) {
                object.frontCount++;

                if(object.state[i].isAngle) {
                    object.angleFront = true;
                }
            }
            if (object.state[i]['position'] === 'back' && !object.state[i]['isChair']) {
                object.backCount++;

                if(object.state[i].isAngle) {
                    object.angleBack = true;
                }
            }
            if (object.state[i]['position'] === 'frontLeft' && !object.state[i]['isChair']) {
                object.frontLeftCount++;

                if(object.state[i].isAngle) {
                    object.angleFrontLeft = true;
                }
            }
        }

        if(item.prepends) {
            queuePosition = 'prepend';
        }
        else {
            queuePosition = 'append';
        }

        if(position === 'front') {

            x = (object.position.x + sectionObject['image']['front'][queuePosition]['offsetX']) + Number(item.shiftedX);
            y = (object.position.y + sectionObject['image']['front'][queuePosition]['offsetY']) + Number(item.shiftedY);

            object.position.x += sectionObject['image']['front'][queuePosition]['sizeX'];
            object.position.y += sectionObject['image']['front'][queuePosition]['sizeY'];

        }

        if(position === 'frontLeft') {

            x = (object.position.x + sectionObject['image']['frontLeft'][queuePosition]['offsetX']) + Number(item.shiftedX);
            y = (object.position.y + sectionObject['image']['frontLeft'][queuePosition]['offsetY']) + Number(item.shiftedY);

            object.position.x += sectionObject['image']['frontLeft'][queuePosition]['sizeX'];
            object.position.y += sectionObject['image']['frontLeft'][queuePosition]['sizeY'];

        }

        if(position === 'frontRight') {

            x = (object.position.x + sectionObject['image']['frontRight'][queuePosition]['offsetX']) + Number(item.shiftedX);
            y = (object.position.y + sectionObject['image']['frontRight'][queuePosition]['offsetY']) + Number(item.shiftedY);

            object.position.x -= sectionObject['image']['frontRight'][queuePosition]['sizeX'];
            object.position.y -= sectionObject['image']['frontRight'][queuePosition]['sizeY'];

        }

        if(position === 'back') {

            x = (object.position.x + sectionObject['image']['back'][queuePosition]['offsetX']) + Number(item.shiftedX);
            y = (object.position.y + sectionObject['image']['back'][queuePosition]['offsetY']) + Number(item.shiftedY);

            object.position.x -= sectionObject['image']['back'][queuePosition]['sizeX'];
            object.position.y -= sectionObject['image']['back'][queuePosition]['sizeY'];

        }


        

        

        return {x:x, y:y, objectPosition:objectPosition}
    }

    /**
     * Если включен режим дебага можем нарисовать обводку модуля самостоятельно
     * hand border making (get coordinates)
     * */
    borderCoordinatesByClick(node) {
        let object = this;
        let coordinates = [];
        let lineArr = [];
        let borderLine;
        let sectionObject = object.sections[node.info.item.id];
        node.off('click');

        node.on('click', function () {

            object.group.find('.borderLine').destroy();
            lineArr = [];
            let position = object.helpers.getRelativePointerPosition(node);

            coordinates.push({
                x: Math.round(sectionObject.flip ? ((position.x * -1) + object.imageSize) : position.x),
                y: Math.round(position.y)
            });

            borderLine = new Konva.Shape({
                x: node.info.item.x,
                y: node.y(),
                width: node.width(),
                height: node.height(),
                scaleX: object.scale,
                scaleY: object.scale,
                strokeWidth: 4,
                stroke: '#ffffff',
                fillEnabled: true,
                listening: false,
                name: 'borderLine',
                sceneFunc: function (context, shape) {
                    context.beginPath();

                    context.lineWidth = 2 / object.scale;
                    context.strokeStyle = '#ffffff';
                    context.moveTo(coordinates[0].x, coordinates[0].y);

                    coordinates.forEach(function (item, index) {
                        context.lineTo(item.x, item.y);
                    });

                    context.stroke();
                }
            });

            borderLine.zIndex(10000);

            object.group.add(borderLine);

            object.configurator.layer.draw();

            object.coordinatesShape = {
                coordinates: coordinates,
                info: node.info
            };
        });
    }

    /**
     * Включить режим дебага
     * Turn on debug
    * */
    turnOnDebug(x, y, image, shape, pillowItem, on = true) {

        if(on) {
            let debuggingWindow = $('#debuggingCanvas');
            let refreshSofa = $('.refresh-sofa');
            let checkAllCanvasMaterials = $('.js-check-all-canvas-materials');
            let synchronizeCanvasTranslations = $('.js-synchronize-canvas-translations');
            let setOffsetsButton = $('#setOffsets');
            let setCoordinatesButton = $('#setCoordinates');
            let object = this;
            let newOffsetX = (image.x() - image.objectPosition.x)
            let newOffsetY = (image.y() - image.objectPosition.y)
            let sectionObject = object.sections[image.info.item.id]

            if (window.innerWidth <= 768) refreshSofa.css('top', '24px');

            debuggingWindow.show();
            refreshSofa.show();
            checkAllCanvasMaterials.show();
            synchronizeCanvasTranslations.show();

            refreshSofa.on('click', function(e){
                e.preventDefault();
                sessionStorage.removeItem('canvasState');
                window.location.reload();
            });

            setCoordinatesButton.on('click', function () {
                object.helpers.setCoordinatesToAdmin(object.coordinatesShape, object);
            });

            let rectItemPoint = new Konva.Circle({
                x: x,
                y: y,
                radius: 5,
                fill: 'black',
            });
            object.group.add(rectItemPoint);
            rectItemPoint.zIndex(object.group.children.length);

            let rectPositionPoint = new Konva.Circle({
                x: object.position.x,
                y: object.position.y,
                radius: 5,
                fill: 'red',
            });
            rectPositionPoint.zIndex(object.group.children.length);
            object.group.add(rectPositionPoint);

            let offsetSizeFix = object.configurator.noModuleSofa.offsetSizeFix;
            let initialX = image.x();
            let initialY = image.y();

            image.on('dragstart', function () {
                debuggingWindow.find('.offsetX').text(Math.round(initialX - image.objectPosition.x));
                debuggingWindow.find('.offsetY').text(Math.round(initialY - image.objectPosition.y));
            });

            image.on('dragmove', function () {
                debuggingWindow.find('.offsetX').text(Math.round(image.x() - image.objectPosition.x));
                debuggingWindow.find('.offsetY').text(Math.round(image.y() - image.objectPosition.y));
            });

            image.on('dragend', function () {
                setOffsetsButton.off('click');

                newOffsetX = ((image.x() - image.objectPosition.x) / offsetSizeFix) - image.info.item.shiftedX;
                newOffsetY = ((image.y() - image.objectPosition.y) / offsetSizeFix) - image.info.item.shiftedY;

                let newOffsetXFixed = sectionObject.flip ? (newOffsetX - object.imageSize * object.scale) : newOffsetX
                
                debuggingWindow.find('.offsetX').text(Math.round(newOffsetXFixed));
                debuggingWindow.find('.offsetY').text(Math.round(newOffsetY));

                shape.x(image.x());
                shape.y(image.y());

                setOffsetsButton.on('click', function () {
                    object.helpers.setOffsetsToAdmin(newOffsetXFixed, newOffsetY, image, object);
                });
            });

            image.cache({
                // drawBorder: true
            });

            pillowItem.cache({
                drawBorder: true
            })

            object.borderCoordinatesByClick(image);
            object.setSizes(image);
            object.setShifts(image);
        }
    }

    /**
     * Получить крайние модули
     * */
    setEdgeModules(draggingDistancedModule = false) {

        let object = this;
        if(object.state.length === 0) {
            return;
        }

        let shapeRadius = object.configurator.addModuleRadius
        let first, last, firstAbsolute, lastAbsolute
        let scale = object.group.scaleX()
        let groupX = object.group.x()
        let groupY = object.group.y()
        let imgWidth = (object.imageSize * object.scale) * scale
        let edgeModulesIndexes = object.helpers.getEdgeModuleIndex(object, draggingDistancedModule)

        last = object.state[edgeModulesIndexes.lastIndex]
        first = object.state[edgeModulesIndexes.firstIndex]
        firstAbsolute = object.state[0]
        lastAbsolute = object.state[object.state.length - 1]

        let k = scale;
        let points = [[first.x, first.y], [last.x, last.y]];
        let pointsAbsolute = [[firstAbsolute.x, firstAbsolute.y], [lastAbsolute.x, lastAbsolute.y]];

        /*Получаем новые координаты точек*/
        let newPoints = object.helpers.getScaledDots(k, points);
        let newPointsAbsolute = object.helpers.getScaledDots(k, pointsAbsolute);

        object.edgeModules['first'] = {
            centerX: groupX + newPoints[0][0] + imgWidth/2,
            centerY: groupY + newPoints[0][1] + imgWidth/2,
            item: first,
            index: edgeModulesIndexes.firstIndex
        };

        object.edgeModules['last'] = {
            centerX: groupX + newPoints[1][0] + imgWidth/2,
            centerY: groupY + newPoints[1][1] + imgWidth/2,
            item: last,
            index: edgeModulesIndexes.lastIndex
        };

        object.edgeModules['firstAbsolute'] = {
            centerX: groupX + newPointsAbsolute[0][0] + imgWidth/2,
            centerY: groupY + newPointsAbsolute[0][1] + imgWidth/2,
            item: firstAbsolute,
            index: 0
        };

        object.edgeModules['lastAbsolute'] = {
            centerX: groupX + newPointsAbsolute[1][0] + imgWidth/2,
            centerY: groupY + newPointsAbsolute[1][1] + imgWidth/2,
            item: lastAbsolute,
            index: object.state.length - 1
        };

        /*Если включен режим дебага рисуем центр + область*/
        if(object.debug) {
            object.configurator.layer.find('.firstCenter').destroy();
            object.configurator.layer.find('.lastCenter').destroy();
            object.configurator.layer.find('.firstCenterText').destroy();
            object.configurator.layer.find('.lastCenterText').destroy();
            object.configurator.layer.find('.firstCenterRadius').destroy();
            object.configurator.layer.find('.lastCenterRadius').destroy();

            let firstCenter = new Konva.Rect({
                x: object.edgeModules['first'].centerX - 25,
                y: object.edgeModules['first'].centerY - 25,
                width: 50,
                height: 50,
                listening: false,
                fill: 'green',
                name: 'firstCenter'
            });
            let firstCenterText = new Konva.Text({
                x: object.edgeModules['first'].centerX - 25,
                y: object.edgeModules['first'].centerY - 25,
                width: 50,
                height: 50,
                text: object.edgeModules['first'].item.prepends ? 'против часовой' : 'по часовой',
                listening: false,
                fill: 'white',
                name: 'firstCenterText'
            });
            let firstCenterRadius = new Konva.Shape({
                x: object.edgeModules['first'].centerX,
                y: object.edgeModules['first'].centerY,
                strokeWidth: 3,
                stroke: 'green',
                fillEnabled: true,
                listening: false,
                width: 20,
                height: 20,
                name: 'firstCenterRadius',
                sceneFunc: function (context, shape) {
                    context.beginPath();

                    context.lineTo(-shapeRadius, shapeRadius);
                    context.lineTo(-shapeRadius, -shapeRadius);
                    context.lineTo(+shapeRadius, -shapeRadius);
                    context.lineTo(+shapeRadius, +shapeRadius);

                    context.closePath();
                    context.fillStrokeShape(shape);
                }
            });
            object.configurator.layer.add(firstCenter);
            object.configurator.layer.add(firstCenterText);
            object.configurator.layer.add(firstCenterRadius);

            let lastCenter = new Konva.Rect({
                x: object.edgeModules['last'].centerX - 25,
                y: object.edgeModules['last'].centerY - 25,
                width: 50,
                height: 50,
                listening: false,
                fill: 'violet',
                name: 'lastCenter'
            });
            let lastCenterText = new Konva.Text({
                x: object.edgeModules['last'].centerX - 25,
                y: object.edgeModules['last'].centerY - 25,
                width: 50,
                height: 50,
                text: object.edgeModules['last'].item.prepends ? 'против часовой' : 'по часовой',
                listening: false,
                fill: 'white',
                name: 'lastCenterText'
            });
            let lastCenterRadius = new Konva.Shape({
                x: object.edgeModules['last'].centerX,
                y: object.edgeModules['last'].centerY,
                strokeWidth: 3,
                stroke: 'violet',
                listening: false,
                fillEnabled: true,
                width: 20,
                height: 20,
                name: 'lastCenterRadius',
                sceneFunc: function (context, shape) {

                    context.beginPath();

                    context.lineTo(-shapeRadius, shapeRadius);
                    context.lineTo(-shapeRadius, -shapeRadius);
                    context.lineTo(+shapeRadius, -shapeRadius);
                    context.lineTo(+shapeRadius, +shapeRadius);

                    context.closePath();
                    context.fillStrokeShape(shape);
                }
            });
            object.configurator.layer.add(lastCenterRadius);
            object.configurator.layer.add(lastCenter);
            object.configurator.layer.add(lastCenterText);
        }

        object.prevScale = scale;
    }

    /**
     * Если включен режим дебага, можем устанавливать размеры модуля своими руками
     * */
    setSizes(image) {
        let object = this;
        let inputSizeX = $('#sizeX');
        let inputSizeY = $('#sizeY');
        let setSizes = $('#setSizes');
        let offsetSizeFix = object.configurator.noModuleSofa.offsetSizeFix;
        let sizeCoeff = (offsetSizeFix - ((offsetSizeFix - 1) / 2))

        image.on('click', function () {
            inputSizeX.off('change');
            inputSizeY.off('change');
            setSizes.off('click');

            if(object.configData.noModuleSofa) {
                inputSizeX.val(image.info.sizeX / sizeCoeff);
                inputSizeY.val(image.info.sizeY / sizeCoeff);
            }
            else {
                inputSizeX.val(image.info.sizeX);
                inputSizeY.val(image.info.sizeY);
            }

            inputSizeX.on('change', function () {
                let ths = $(this);
                let moduleId = image.info.moduleId;
                let pos = image.info.position;
                let queuePos = image.info.queuePosition;
                if(object.configData.noModuleSofa) {
                    object.configData.sections[0][moduleId]['image'][pos][queuePos]['sizeX'] = Number(ths.val()) * sizeCoeff;
                }
                else {
                    object.configData.sections[0][moduleId]['image'][pos][queuePos]['sizeX'] = Number(ths.val())
                }
                object.rebuild();
                object.configurator.layer.draw();
            });

            inputSizeY.on('change', function () {
                let ths = $(this);
                let moduleId = image.info.moduleId;
                let pos = image.info.position;
                let queuePos = image.info.queuePosition;
                if(object.configData.noModuleSofa) {
                    object.configData.sections[0][moduleId]['image'][pos][queuePos]['sizeY'] = Number(ths.val()) * sizeCoeff;
                }
                else {
                    object.configData.sections[0][moduleId]['image'][pos][queuePos]['sizeY'] = Number(ths.val())
                }
                object.rebuild();
                object.configurator.layer.draw();
            });

            setSizes.on('click', function () {
                let sizeX = inputSizeX.val();
                let sizeY = inputSizeY.val();

                object.helpers.setSizesToAdmin(sizeX, sizeY, image, object);
            })
        });
    }

    /**
     * Если включен режим дебага, можем устанавливать сдвиг модуля своими руками
     * */
    setShifts(image) {
        let object = this;
        let inputShiftX = $('#shiftX');
        let inputShiftY = $('#shiftY');
        let setShifts = $('#setShifts');

        image.on('click', function () {
            inputShiftX.off('change');
            inputShiftY.off('change');
            setShifts.off('click');

            inputShiftX.val(image.info.shiftX);
            inputShiftY.val(image.info.shiftY);

            inputShiftX.on('change', function () {
                let val = {
                    x: Number(inputShiftX.val()),
                    y: Number(inputShiftY.val())
                }
                object.helpers.addShiftDynamic(object, image.info.item, val)
                object.rebuild();
                object.configurator.layer.draw();
            });

            inputShiftY.on('change', function () {
                let val = {
                    x: Number(inputShiftX.val()),
                    y: Number(inputShiftY.val())
                }
                object.helpers.addShiftDynamic(object, image.info.item, val)
                object.rebuild();
                object.configurator.layer.draw();
            });

            setShifts.on('click', function () {
                let shiftX = inputShiftX.val();
                let shiftY = inputShiftY.val();

                object.helpers.setShiftsToAdmin(shiftX, shiftY, image, object);
            })
        });
    }
}

export default ConfiguratorSofa;
